'use client';

import { c as _c } from "react/compiler-runtime";
import { HorizontalOverflowCarousel } from '@petsmart-ui/sparky';
import { clsx } from '@libs/common-next';
import { useWhiteSpaceCalculation } from '../../hooks';
import { productCarouselConfig } from '../../utils/productCarouselConfig';
import type { CarouselProps } from './types';
export function Carousel(t0) {
  const $ = _c(17);
  const {
    children,
    productHits,
    variant,
    isInDrawer
  } = t0;
  const whiteSpaceCalculate = useWhiteSpaceCalculation();
  let carouselConfig;
  let t1;
  if ($[0] !== isInDrawer || $[1] !== productHits.length || $[2] !== variant) {
    const {
      disableArrows,
      ...t2
    } = productCarouselConfig(isInDrawer, variant, productHits.length);
    carouselConfig = t2;
    t1 = clsx("product-carousel__carousel", disableArrows && "product-carousel__carousel--disable-arrows");
    $[0] = isInDrawer;
    $[1] = productHits.length;
    $[2] = variant;
    $[3] = carouselConfig;
    $[4] = t1;
  } else {
    carouselConfig = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== carouselConfig || $[6] !== t1) {
    t2 = {
      className: t1,
      ...carouselConfig
    };
    $[5] = carouselConfig;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const carouselOptions = t2;
  let t3;
  if ($[8] !== carouselOptions.breakpoints || $[9] !== isInDrawer || $[10] !== productHits.length || $[11] !== whiteSpaceCalculate) {
    t3 = translate => {
      const {
        gap,
        perView
      } = carouselOptions.breakpoints["560"];
      if (whiteSpaceCalculate) {
        const qytTiles = productHits.length;
        return whiteSpaceCalculate(translate, perView, gap, qytTiles, isInDrawer);
      }
      return translate;
    };
    $[8] = carouselOptions.breakpoints;
    $[9] = isInDrawer;
    $[10] = productHits.length;
    $[11] = whiteSpaceCalculate;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const modifier = t3;
  let t4;
  if ($[13] !== carouselOptions || $[14] !== children || $[15] !== modifier) {
    t4 = <HorizontalOverflowCarousel {...carouselOptions} modifier={modifier}>{children}</HorizontalOverflowCarousel>;
    $[13] = carouselOptions;
    $[14] = children;
    $[15] = modifier;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}